import { hydrate } from 'preact-iso'
import './index.css'
import { Root } from './app'

hydrate(<Root />, document.getElementById('app')!)
